import React, { useState } from "react";
import signUp from "../../actions/signUp";
import Loader from "../Loader";
import Field from "./Field";

const SignUp = ({ setSignUp, goToSignIn }) => {
  const [fullName, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [result, setResult] = useState({});
  const [loading, setLoading] = useState(false);

  const setSignUpResult = (result) => {
    setLoading(false);
    setResult(result);
    setSignUp(result.status === "success");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const regexPattern = /\s+/g;
    const formatedFullName = fullName
      .trim()
      .replace(regexPattern, " ")
      .split(" ");

    const firstName = formatedFullName[0];
    const lastName = formatedFullName[1] || "";

    signUp(
      firstName,
      lastName,
      email,
      password,
      window.location.href,
      setSignUpResult
    );
  };

  return (
    <>
      <form className="login__form" onSubmit={handleSubmit}>
        <Field
          label="Full name"
          value={fullName}
          type="text"
          onChange={(e) => setFullname(e.target.value)}
          placeholder="Jamie Davis"
        />
        <Field
          label="Email"
          value={email}
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          placeholder="desigder@example.com"
        />
        <Field
          label="Password"
          value={password}
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
        />
        {result.error && (
          <div className="login__error">{result.error}</div>
        )}
        {loading ? (
          <Loader />
        ) : (
          <button className="login__btn">Sign up</button>
        )}
      </form>
      <div className="login__hint">
        Already have an account? <button onClick={goToSignIn}>Log in</button>
      </div>
    </>
  );
};

export default SignUp;
